import type {Request} from 'express';
import {isAppCheckoutRequest} from './isAppCheckout';

const APP_LINKS_SUB_DOMAINS = [
  'app.aboutyou.com',
  'app.aboutyou-staging.com',
  // local testing
  'app.aboutyou.com.local',
  'app.aboutyou-staging.com.local',
];

export const isAppLinksSubdomainRequest = (req: Request) => {
  return APP_LINKS_SUB_DOMAINS.includes(req.hostname);
};

export const isAppCheckoutSubdomainRequest = (req: Request) => {
  if (!isAppLinksSubdomainRequest(req)) {
    return false;
  }

  const isAppCheckoutWithOriginHostname = Boolean(
    isAppCheckoutRequest(req) && req.query.originHostname,
  );

  return isAppCheckoutWithOriginHostname;
};

/**
 * App Subdomain requests should always use the assets from `.com` checkout domain
 */
export const getAppCheckoutAssetsHostOverride = (req: Request) => {
  return {
    'app.aboutyou.com': 'https://checkout-v3.aboutyou.com',
    'app.aboutyou-staging.com': 'https://checkout-v3.aboutyou-staging.com',

    // local testing
    'app.aboutyou.com.local': 'https://checkout-v3.aboutyou.com',
    'app.aboutyou-staging.com.local':
      'https://checkout-v3.aboutyou-staging.com',
  }[req.hostname];
};
